import React from "react";

import annalisa from "./pics/community_1.png";
import group_pic_1 from "./pics/community_2.png";
import group_pic_2 from "./pics/community_3.png";
import group_pic_3 from "./pics/community_4.png";
import group_pic_4 from "./pics/community_5.png";
import sabrina from "./pics/community_6.png";
import group_pic_5 from "./pics/community_7.png";
import group_pic_6 from "./pics/community_8.jpeg";
import group_pic_7 from "./pics/community_9.jpeg";
import group_pic_8 from "./pics/community_10.png";
import cogan from "./pics/community_11.png";
import group_pic_9 from "./pics/community_12.jpeg";
import group_pic_10 from "./pics/community_13.jpeg";
import group_pic_11 from "./pics/community_14.jpeg";
import group_pic_12 from "./pics/community_15.jpeg";
import group_pic_13 from "./pics/community_16.png";
import blerina from "./pics/community_17.png";
import group_pic_14 from "./pics/community_18.jpeg";
import group_pic_15 from "./pics/community_19.jpeg";
import group_pic_16 from "./pics/community_20.jpeg";
import group_pic_17 from "./pics/community_21.jpeg";
import group_pic_18 from "./pics/community_22.jpeg";
import juan from "./pics/community_23.png";
import gong from "./pics/community_24.png";
import group_pic_19 from "./pics/community_25.jpeg";
import group_pic_20 from "./pics/community_26.jpeg";

export const Community = () => {
    return (
        <>
            <div className="mt-[74px] px-4 pt-2 bg-white flex items-center justify-center">
            </div>
            <br />
            <div className="flex justify-start items-start flex-col pt-10 pb-0 lg:pt-16 lg:pb-4 mb-4 lg:my-6 lg:h-auto lg:px-32 px-8 overflow-visible">
                <p style={{ color: '#e94607' }} className="text-3xl font-bold mb-4 lg:mx-10 sm:mx-2 tracking-wide text-center">A community that fosters meaningful connections</p>
                <div className="text-md lg:text-lg font-[300] lg:mx-10 sm:mx-2">

                    <p>Over the years, <b>ISWC (International Semantic Web Conference)</b> has brought together a vibrant, global community of researchers, developers, and enthusiasts passionate about the Semantic Web. More than just a venue for academic exchange, ISWC has fostered countless collaborations, sparked innovative ideas, and built lasting friendships.</p>

                    <p>Beyond the technical sessions and paper presentations, ISWC is also known for its unforgettable social events - scenic excursions, lively banquets, and moments of fun that bring the community closer together. From shared laughter during excursions to memorable evenings at conference dinners, these experiences have become just as meaningful as the research itself.</p>

                    <p>In this post, we take a moment to look back through the eyes of past attendees - who have generously shared their memories, photos, and reflections. Their stories capture the energy, camaraderie, and spirit that make ISWC a highlight of the year for so many in the Semantic Web community.</p>

                    <br />
                    <div className="flex items-center gap-4">
                        <div className="w-24 h-24 overflow-hidden">
                            <img
                                src={annalisa}
                                alt="Anna Lisa Gentile"
                                className="object-cover w-full h-full"
                            />

                        </div>
                        <p className="text-lg font-semibold">
                            Anna Lisa Gentile{' '}
                            <span className="font-normal italic text-gray-600">
                                – Senior Research Scientist, IBM Research, US
                            </span>
                        </p>
                    </div>

                    <p>I’ve been attending ISWC for nearly 15 years now.</p>

                    <p>I can't help but smile at all the fantastic memories. Sure, the scientific sessions have always been great, and I still remember nervously presenting my paper in Sydney in 2013, with lots of the scientists I admire in the audience. But what makes ISWC unforgettable for me are all the connections I made. ISWC has been so much more than just talks and presentations year after year - there are always fun activities that bring people together.</p>

                    <p>One of my most memorable ISWC events is the Bike Ride from my IBM office in San Jose, California, to the conference venue of ISWC 2018 in Monterey. Together with 13 other fellow ISWC-ers, we rode for two days, even stopping for a jump in the sea in Santa Cruz. Unforgettable! </p>

                    <img src={group_pic_1} alt="Group Picture" className="rounded-xl my-4" />
                    <img src={group_pic_2} alt="Group Picture" className="rounded-xl my-4" />
                    <img src={group_pic_3} alt="Group Picture" className="rounded-xl my-4" />
                    <img src={group_pic_4} alt="Group Picture" className="rounded-xl my-4" />

                    <p>Another event close to my heart is the <a href="http://iswc2018.semanticweb.org/ada-lovelace-celebration/index.html" target="_blank" style={{ color: '#e94607' }}> ISWC Ada Lovelace Day celebration</a>. To honor the achievements of our Semantic Web women, we organized a Wikipedia edit-a-thon to create pages for those in our community who didn't have a page yet – we proudly added a few during the event, including <a href="https://en.wikipedia.org/wiki/Natasha_Noy" style={{ color: '#e94607' }} target="_blank">Natasha Noy</a> and <a href="https://en.wikipedia.org/wiki/Lora_Aroyo" style={{ color: '#e94607' }} target="_blank">Lora Aroyo</a>.</p>

                    <br />
                    <br />
                    <div className="flex items-center justify-end p-0 m-0 w-full">
                        <div className="text-right text-lg font-semibold leading-snug">
                            Sabrina Kirrane{' '}
                            <span className="font-normal italic text-gray-600">
                                – Associate Professor, Institute for Complex Networks, Vienna University of Economics and Business, Austria
                            </span>
                        </div>
                        <div className="w-24 h-24 overflow-hidden flex-shrink-0 ml-2">
                            <img
                                src={sabrina}
                                alt="Sabrina Kirrane"
                                className="object-cover w-full h-full block"
                            />
                        </div>
                    </div>

                    <p className="text-right">My first organizing committee role was sponsorship co-chair for ISWC 2017 in Vienna. Anyone who has taken on this role will tell you it’s not an easy job. The highlight for me was the jam session on the first day of the conference. The entire Texan-themed evening, including cowboy hats and a cocktail bar, was kindly sponsored by data.world. The turnout was fantastic, our ISWC musicians and singers were amazing, and the atmosphere was simply electric! </p>

                    <p lassName="text-right">Since then I’ve co-organized the doctoral consortium in 2018, co-coordinated the workshops and tutorials in 2020, and co-chaired the panel in 2024. Each role was a learning opportunity where I was presented with different challenges and opportunities. I very much appreciate the significant impact these roles and the various individuals I have interacted with along the way have played in my own academic journey. It really is a true honor to take on the research track co-chair role for 2025!</p>

                    <img src={group_pic_5} alt="Group Picture" className="rounded-xl my-4 h-[500px]" />
                    <img src={group_pic_6} alt="Group Picture" className="rounded-xl my-4 h-[500px]" />
                    <img src={group_pic_7} alt="Group Picture" className="rounded-xl my-4 h-[500px]" />
                    <img src={group_pic_8} alt="Group Picture" className="rounded-xl my-4 h-[500px]" />

                    <br />
                    <br />
                    <div className="flex items-center gap-4">
                        <div className="w-24 h-24 overflow-hidden">
                            <img
                                src={cogan}
                                alt="Cogan Shimizu"
                                className="object-cover w-full h-full"
                            />

                        </div>
                        <p className="text-lg font-semibold">
                            Cogan Shimizu{' '}
                            <span className="font-normal italic text-gray-600">
                                – Assistant Professor at Wright State University in the Department of Computer Science & Engineering, USA
                            </span>
                        </p>
                    </div>

                    <p>I started my ISWC journey in 2017 (Vienna), where I presented my first paper ever at the Workshop on Ontology Design and Patterns. I’m in the red – all the way to the right. I have distinctly fond memories of the experience, but most importantly, I learned – and experienced – how incredibly welcoming the community was. Indeed, Axel Polleres picked me out of the random Vienna crowd to get me to the right buildings (if I remember correctly the main conference was held in a different place than the workshops, and I missed that memo).</p>

                    <img src={group_pic_9} alt="Group Picture" className="rounded-xl my-4" />

                    <p>Over the years since then, I’ve tried to attend as much as possible, either to present my research or stay engaged with the community, as well as the cohorts of DaSe Lab members that came before and after me, and culminating in three generations of PhD students (DaSe Lab, KASTLE Lab, and KRACR Lab) at ISWC 2024 in Baltimore!</p>


                    <img src={group_pic_10} alt="Group Picture" className="rounded-xl my-4" />

                    <p>Monterey – Cogan Shimizu, Michelle Cheatham, MD Sarker, Lu Zhou</p>



                    <div className="flex flex-col gap-8 w-full">
                        {/* Top Row: 2 images, each 50% width */}
                        <div className="flex w-full">
                            {/* Auckland */}
                            <div className="w-1/2 flex flex-col items-center">
                                <div className="w-full h-[500px] overflow-hidden">
                                    <img
                                        src={group_pic_11}
                                        alt="Auckland group"
                                        className="w-full h-full object-cover rounded-xl"
                                    />
                                </div>
                                <p className="text-center text-sm mt-2 px-4">
                                    Auckland, with previous DaSe graduates (Adila Krisnadhi, left; Raghava Mutharaju, right).
                                </p>
                            </div>

                            {/* Athens */}
                            <div className="w-1/2 flex flex-col items-center">
                                <div className="w-full h-[500px] overflow-hidden">
                                    <img
                                        src={group_pic_12}
                                        alt="Athens group"
                                        className="w-full h-full object-cover rounded-xl"
                                    />
                                </div>
                                <p className="text-center text-sm mt-2 px-4">
                                    Athens – Raghava Mutharaju, Saeid Mahdavinejad, Cogan Shimizu
                                </p>
                            </div>
                        </div>

                        {/* Bottom image: full width */}
                        <div className="w-full">
                            <div className="w-full h-[700px] overflow-hidden">
                                <img
                                    src={group_pic_13}
                                    alt="ISWC 2024 group"
                                    className="w-full h-full object-cover rounded-xl"
                                />
                            </div>
                            <p className="text-center text-sm mt-2 px-4">
                                Members of the Data Semantics Laboratory, KONKORDANT Laboratory, KRACR Lab, and KASTLE Lab –
                                a growing cohort (and three generations) of knowledge engineering research, connecting at ISWC 2024!
                            </p>
                        </div>
                    </div>

                    <br />
                    <br />
                    <div className="flex items-center justify-end p-0 m-0 w-full">
                        <div className="text-right text-lg font-semibold leading-snug">
                            Blerina Spahiu{' '}
                            <span className="font-normal italic text-gray-600">
                                – Associate Professor, Bicocca University, Italy
                            </span>
                        </div>
                        <div className="w-24 h-24 overflow-hidden flex-shrink-0 ml-2">
                            <img
                                src={blerina}
                                alt="Blerina Spahiu"
                                className="object-cover w-full h-full block"
                            />
                        </div>
                    </div>

                    <p className="text-right">I’ll never forget my first ISWC back in 2015. I was a PhD student at the time, and it was held in Pennsylvania, USA. It was also the first time I got to experience the Semantic Web community in person. I was honestly a bit nervous going in. You know, stepping into a big international conference as a newbie can feel overwhelming. But the community? So warm, so welcoming. People were kind, open, and genuinely excited to connect and share ideas. It didn’t take long before I felt right at home.
                        And the social event? An absolute blast! It was full of laughter, dancing, and just pure fun. I remember thinking, “Wow, this field isn’t just intellectually exciting! It’s also full of really awesome people.”</p>

                    <div className="w-full flex justify-end">
                        <div className="w-[900px] overflow-hidden">
                            <img
                                src={group_pic_14}
                                alt="Group Picture"
                                className="w-full h-full object-cover rounded-xl"
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="w-full flex justify-end">
                        <div className="w-[400px] overflow-hidden">
                            <img
                                src={group_pic_15}
                                alt="Group Picture"
                                className="w-full h-full object-cover rounded-xl"
                            />
                        </div>
                    </div>

                    <p className="text-right">That first ISWC still holds a special place in my heart. It wasn’t just a conference, it was the moment I truly felt part of the community. ISWC 2018, held in beautiful Monterey, California, holds a very special place in my heart. It was one of those conferences where everything felt just right—the venue, the energy, the talks, the ocean breeze just outside the sessions. </p>


                    <div className="flex flex-col gap-8 w-full">
                        <div className="flex w-full">
                            <div className="w-1/2 flex flex-col items-center">
                                <div className="w-full h-[500px] overflow-hidden">
                                    <img
                                        src={group_pic_16}
                                        alt="Auckland group"
                                        className="w-full h-full object-cover rounded-xl"
                                    />
                                </div>
                            </div>
                            <div className="w-1/2 flex flex-col items-center">
                                <div className="w-full h-[500px] overflow-hidden">
                                    <img
                                        src={group_pic_17}
                                        alt="Athens group"
                                        className="w-full h-full object-cover rounded-xl"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <p className="text-right">But more than that, it was the people who made it unforgettable. We shared laughs over coffee breaks, inspiring conversations during the sessions, and quiet reflections during walks by the shore.</p>

                    <p className="text-right">Looking back now, I cherish those moments more than ever. It reminds me that conferences are not only about research and papers but about the human connections that form around them.</p>

                    <div className="w-full flex justify-end">
                        <div className="w-[500px] overflow-hidden">
                            <img
                                src={group_pic_18}
                                alt="Group Picture"
                                className="w-full h-full object-cover rounded-xl"
                            />
                        </div>
                    </div>

                    <p className="text-right">Blerina Spahiu, Anisa Rula, Amrapali Zaveri (RIP) at the Monterey Aquarium for the social dinner at ISWC 2018.</p>

                    <br/>
                    <br/>

                    <div className="flex items-center gap-4">
                        <div className="w-24 h-24 overflow-hidden">
                            <img
                                src={juan}
                                alt="Juan Sequeda"
                                className="object-cover w-full h-full"
                            />

                        </div>
                        <p className="text-lg font-semibold">
                        Juan Sequeda{' '}
                            <span className="font-normal italic text-gray-600">
                                – Principal Scientist & Head of AI Lab at data.world, USA. A co-host of Catalog & Cocktails.
                            </span>
                        </p>
                    </div>

                    <p>ISWC has been my academic home since the beginning of my Ph.D. I attended my first conference in 2008 in Karlsruhe and since then, I’ve only missed the one in Shanghai. It’s a uniquely eclectic and diverse community—intellectually, scientifically, and in terms of its people.</p>

                    <p>At that first 2008 conference, I attended a tutorial on Linked Data, and in the final 10 minutes, a student gave the coolest part of that tutorial. That student was Olaf Hartig and since then we’ve been best friends. I also gave a poster presentation on the early work I had just started in my Ph.D. Later, I learned that someone who visited my poster remembered me years afterward—Professor George Fletcher. Nearly 10 years later, we ended up collaborating on various projects. He first met me at that poster, and that memory stayed with him. This is why I’m such a strong advocate for poster sessions—they’re a powerful way to share your ideas, test your elevator pitch, and engage with a wide variety of people in a short time.</p>

                    <p>Another memorable moment was in 2014 in Riva del Garda, when I was nominated for the Best Paper Award. One of the selection criteria involved how well the paper was presented, so I focused intensely on my presentation. I practiced and even asked professors at the conference to review my slides and give me feedback. Their insights helped me polish my talk, and I believe that played a big role in winning the award.</p>

                    <p>The social side of this conference is also incredibly special. After the 2015 conference in Bethlehem, Pennsylvania, I celebrated my 30th birthday by going to New York City with close friends from the community for several days of celebrations. Another standout memory is the boat party during the 2013 conference in Sydney with the band formed by our colleagues. We then ended up dancing salsa in the harbor till early morning. </p>

                    <p>All of this highlights a central truth: science is a social process. The Semantic Web community has become not only my scientific and professional network but also a close-knit group of friends. Among all the conferences I attend, this is one of the most lively and meaningful.</p>


                    <br />
                    <br />
                    <div className="flex items-center justify-end p-0 m-0 w-full">
                        <div className="text-right text-lg font-semibold leading-snug">
                            Gong Cheng{' '}
                            <span className="font-normal italic text-gray-600">
                                – professor at the School of Computer Science, Nanjing University, China
                            </span>
                        </div>
                        <div className="w-24 h-24 overflow-hidden flex-shrink-0 ml-2">
                            <img
                                src={gong}
                                alt="Gong Cheng"
                                className="object-cover w-full h-full block"
                            />
                        </div>
                    </div>

                    <p className="text-right">The year 2019 remains unforgettable to me—not just for the thrill of my first bungee jumping experience in the Southern Hemisphere, but also for marking my debut as a member of the ISWC organizing committee. The Posters & Demos session has always been my favorite conference highlight, with its vibrant mix of relaxed atmosphere, diverse presentations, and engaging interactions. Let’s work together to make this session another success in 2025, this time in the world’s other hemisphere!</p>

                    <div className="w-full flex justify-end">
                        <div className="w-[700px] overflow-hidden">
                            <img
                                src={group_pic_19}
                                alt="Group Picture"
                                className="w-full h-full object-cover rounded-xl"
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="w-full flex justify-end">
                        <div className="w-[700px] overflow-hidden">
                            <img
                                src={group_pic_20}
                                alt="Group Picture"
                                className="w-full h-full object-cover rounded-xl"
                            />
                        </div>
                    </div>

                    <br/>
                    <p style={{ color: '#e94607' }} className="text-3xl font-bold mb-4 lg:mx-10 sm:mx-2 tracking-wide text-center">Thank You to Our Storytellers!</p>

                    <p>A heartfelt thank you to everyone who shared their ISWC memories and photos for this post. Your stories not only highlight the richness of the ISWC experience but also help preserve the spirit of the community for years to come. We are grateful for your time, reflections, and the glimpse into what makes ISWC meaningful to each of you.</p>

                    <br/>
                    <p style={{ color: '#e94607' }} className="text-3xl font-bold mb-4 lg:mx-10 sm:mx-2 tracking-wide text-center">Your Turn to Make Memories – Onward to ISWC 2025!</p>

                    <p>As we look ahead to ISWC 2025, these shared memories remind us what makes this conference truly special - not just the cutting-edge research, but the people, the connections, and the moments that span continents and careers. Whether you are presenting a paper, diving into a workshop, or simply exploring new ideas, ISWC offers a unique space to grow, collaborate, and be inspired.</p>

                    <p>Let these reflections from past years be your invitation to fully engage with everything ISWC has to offer. Say hello to someone new, join that excursion, attend that social event, ask that question - because often, the most memorable moments happen beyond the slides.</p>

                    <p>We can’t wait to see the memories you’ll create at <b>ISWC 2025!</b></p>

                </div>
            </div>
        </>
    );
}

export default Community;